import React, { useState } from 'react';
import { FaGithub, FaCodeBranch } from 'react-icons/fa';
import Modal from './Modal';
import VersionHistory from '../VersionHistory';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isVersionHistoryOpen, setIsVersionHistoryOpen] = useState(false);
  
  const openVersionHistory = (e) => {
    e.preventDefault();
    setIsVersionHistoryOpen(true);
  };
  
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-content">
          <p>© {currentYear} ToggleBoys Ligan | PuttPals</p>
          <div className="footer-links">
            <a href="#" className="footer-link" onClick={openVersionHistory}>
              <FaCodeBranch /> Versionshistorik
            </a>
            <a 
              href="https://github.com/JohanFernstrom/PuttPals" 
              className="footer-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaGithub /> GitHub
            </a>
          </div>
        </div>
      </div>
      
      {/* Version History Modal */}
      <Modal 
        isOpen={isVersionHistoryOpen} 
        onClose={() => setIsVersionHistoryOpen(false)}
        title="Versionshistorik"
      >
        <VersionHistory />
      </Modal>
    </footer>
  );
};

export default Footer; 